import { CompilerComponent } from '@types';

import { block } from './block';
import { component } from './component';
import { defaultProps, protocolFactory } from './protocol';

export interface SelectOption {
  label: string;
  value: string | number;
}

export interface SelectProps {
  name: string;
  size: 'sm' | 'md' | 'lg';
  value: string;
  label: string;
  placeholder: string;
  options: (SelectOption | string)[];
}

export interface SelectTriggers {
  onBlur: (value: string) => void;
}

export default {
  block,
  component,
  defaultProps,
  protocolFactory,
} as CompilerComponent<SelectProps>;
